import styled from "styled-components"

export interface StyledCardHoverProps {
  background_image: string
  minimum_height: boolean
}

export const StyledCardHover = styled.div<StyledCardHoverProps>`
  ${(props) =>
    props.background_image &&
    `
    background-image: url(${props.background_image});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    `}
  background-color: ${(props) => props.theme.colors.darkGrey};

  ${(props) =>
    props.minimum_height &&
    `
    min-height: 180px;
    @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
      min-height: 120px;
    }
    `}
`
export const StyledDesc = styled.div`
  color: ${(props) => props.theme.colors.white};
  opacity: 0;
  transition: 0.2s ease-in-out;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 14px;
  }
`

export const StyledCardContainer = styled.div`
  position: relative;
  padding: 32px;
  box-shadow: 0 0 16px ${(props) => props.theme.colors.darkGrey10};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &:hover {
    background: ${(props) => props.theme.colors.darkGrey};

    ${StyledDesc} {
      opacity: 1;
    }
  }

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 24px;
  }
`

export const StyledCardLinkWrapper = styled.div``

export const StyledCardLink = styled.div`
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
  top: 0;
  left: 0;
  & a {
    width: 100%;
    height: 100%;
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    color: transparent;
  }
`

export const StyledText = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
export const StyledTextContainer = styled.div``

export const StyledTitleWrapper = styled.div`
  padding: 0;
`

export const StyledTitle = styled.div`
  ${(props) => props.theme.mixins.subsectionTitle};
  color: ${(props) => props.theme.colors.white};

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 18px;
  }
`

export const StyledDescWrapper = styled.div`
  ${(props) => props.theme.mixins.body};
  padding: 16px 0;
`

export const StyledCardButton = styled.div`
  display: flex;
  justify-content: flex-end;

  & .button-v2--text-alt {
    padding: 16px 0 0 0;
    min-height: auto;
  }
`
